export const loadScript = async (
  src: string,
  options: {
    integrity?: string;
    crossOrigin?: string;
  } = {}
) => {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve(undefined);
      return;
    }

    const script = document.createElement('script');
    script.src = src;

    Object.entries(options).forEach(([key, value]) => {
      if (value !== undefined) {
        script[key as keyof typeof options] = value;
      }
    });

    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
};
